import { render, staticRenderFns } from "./ed-course-create-type-object.vue?vue&type=template&id=75655fc8&scoped=true&"
import script from "./ed-course-create-type-object.ts?vue&type=script&lang=ts&"
export * from "./ed-course-create-type-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-create-type-object.scss?vue&type=style&index=0&id=75655fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75655fc8",
  null
  
)

export default component.exports